import { RouteName, TextKey } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useNavigationSearchResult } from './useNavigationSearchResult';
import { AssistantNavigation } from './AssistantNavigation';

export const useOtherNavigation = (): AssistantNavigation[] => {
    const enterpriseId = useCurrentEnterpriseId();
    const dashboardResult = useNavigationSearchResult(RouteName.DashboardIndex, TextKey.Dashboard, {});
    const taskReportResult = useNavigationSearchResult(RouteName.TaskReportIndex, TextKey.TaskPlural, {});
    const messageThreadResult = useNavigationSearchResult(RouteName.MessageThreadIndex, TextKey.MessagePlural, {});
    const enterpriseIntegrationMarketplaceResult = useNavigationSearchResult(
        RouteName.EnterpriseIntegrationMarketplace,
        TextKey.Marketplace,
        { query: { OwnerId: enterpriseId } }
    );

    return [dashboardResult, taskReportResult, messageThreadResult, enterpriseIntegrationMarketplaceResult];
};
